/**
 * Auth Guard — checks if user is logged in.
 * Uses AuthService (in-memory) as primary check, cookie as fallback.
 * This avoids timing issues where cookie was just set but not yet readable.
 */
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Check in-memory user first (set during login, before navigation)
    if (this.authService.currentUser && this.authService.currentUser.email) {
      return true;
    }

    // Not logged in — redirect to login
    this.router.navigate(['/auth/login']);
    return false;
  }
}
